"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_router_dom_1 = require("react-router-dom");
require("materialize-css/js/initial");
require("materialize-css/js/jquery.easing.1.4");
require("materialize-css/js/velocity.min");
require("materialize-css/js/global");
require("materialize-css/js/dropdown");
const App_1 = __importDefault(require("./components/App"));
require("../../sass/ds/styles.scss");
const StoreContext_1 = require("../common/StoreContext");
const services_1 = require("../common/services");
const polyfills_1 = __importDefault(require("../common/polyfills"));
Promise.all(polyfills_1.default)
    .then(() => {
    const store = (0, services_1.createStore)();
    const rootNode = document.getElementById('ds-app');
    const FULL_RELOAD_INTERVAL = 36000000;
    // FIX ME
    // Set the app to reload every 10 hours until we fix the momory leak issue
    setTimeout(() => {
        window.location.reload();
    }, FULL_RELOAD_INTERVAL);
    const reactApp = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StoreContext_1.StoreProviderComponent, { store: store },
            react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
                react_1.default.createElement(App_1.default, null)))));
    if (rootNode) {
        react_dom_1.default.render(reactApp, rootNode);
    }
})
    .catch(error => {
    console.error('Failed fetching polyfills', error);
});
